import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box } from '@mui/material';
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import theme from './theme';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ProjectsSection from './components/ProjectsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import AIAssistant from './components/AIAssistant';

const createEmotionCache = () => {
  return createCache({
    key: "mui",
    prepend: true,
  });
};

const emotionCache = createEmotionCache();

const App: React.FC = () => {
  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box sx={{ minHeight: '100vh' }}>
          <Navigation />
          
          <Box component="main">
            <Box id="hero">
              <HeroSection />
            </Box>
            
            <Box id="about">
              <AboutSection />
            </Box>
            
            <Box id="projects">
              <ProjectsSection />
            </Box>
            
            <Box id="contact">
              <ContactSection />
            </Box>
          </Box>
          
          <Footer />
          
          {/* AI Assistant */}
          <AIAssistant />
        </Box>
      </ThemeProvider>
    </CacheProvider>
  );
};

export default App;